import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import React from "react"
import Icon from "../Elements/Global/atoms/Icons/Icon/Icon"
import { TIconKey } from "../Elements/Global/atoms/Icons/Icon/Interfaces"

interface Props {}

/**
 * Page that lists all possible icons through the `<Icon />` component
 * utilizing `TIconKey` type.
 */
const IconsDevPage = ({}: Props) => {
	let Icons: React.ReactNode[] = []
	let iconKey: TIconKey
	for (iconKey in iconTypes) {
		Icons.push(
			<HyperDiv
				direction="row"
				spaceBetweenElems="1rem"
				style={{
					borderBottom: "1px dashed var(--gray-c2)",
				}}
			>
				<HyperDiv flex={1} hidesOverflownTextAllowingWrap style={{ wordBreak: "break-word" }}>
					{iconKey}
				</HyperDiv>
				<HyperDiv flex={1}>
					<Icon iconKey={iconKey} />
				</HyperDiv>
			</HyperDiv>
		)
	}

	return (
		<HyperDiv direction="column" width={200}>
			{Icons}
		</HyperDiv>
	)
}

export default IconsDevPage

const iconTypes: { [k in TIconKey]: 1 } = {
	"arrow-down": 1,
	"arrow-up": 1,
	"blank-page": 1,
	"error-sign": 1,
	"info-sign": 1,
	"item-type": 1,
	"language-select": 1,
	"warning-sign": 1,
	add: 1,
	arrowLeft: 1,
	arrowLeftEnd: 1,
	arrowRight: 1,
	arrowRightEnd: 1,
	attachment: 1,
	check: 1,
	cross: 1,
	ellipsis: 1,
	exit: 1,
	form: 1,
	layers: 1,
	lock: 1,
	menu: 1,
	minus: 1,
	pencil: 1,
	personalization: 1,
	plus: 1,
	preview: 1,
	save: 1,
	send: 1,
	signal: 1,
	table: 1,
	upload: 1,
	"arrow-down-rounded": 1,
	"arrow-up-rounded": 1,
	email: 1,
	dots: 1,
	calendar: 1,
}
